import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a5857ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto toa-xe-form-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_DanhMucToaXeSearchInput = _resolveComponent("DanhMucToaXeSearchInput")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DanhSachToaXeTable = _resolveComponent("DanhSachToaXeTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isFormDataReady)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              ref: "formRef",
              model: _ctx.toaXeForm,
              rules: _ctx.rules,
              "validate-on-rule-change": false,
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => _ctx.submit(false), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 3
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_LabelCustom, { "is-required": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Nhóm toa xe:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "id_dm_toa_xe",
                            class: "mb-0 w-full"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_DanhMucToaXeSearchInput, {
                                ref: "danhMucToaXeSearchInputRef",
                                key: _ctx.danhMucToaXeInputKey,
                                "full-width": "",
                                id: _ctx.toaXeForm.id_dm_toa_xe,
                                "display-label": _ctx.danhMucToaXeDisplay,
                                "prop-name": "id_dm_toa_xe",
                                onClear: _ctx.onClearDanhMucToaXe,
                                onSelect: _ctx.onSelectDanhMucToaXe
                              }, null, 8, ["id", "display-label", "onClear", "onSelect"]))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_LabelCustom, { "is-required": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tên toa xe:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "ten_toa_xe",
                            class: "mb-0 w-full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                ref: "tenToaXeInputRef",
                                modelValue: _ctx.toaXeForm.ten_toa_xe,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toaXeForm.ten_toa_xe) = $event)),
                                placeholder: "Tên toa xe",
                                name: "ten_toa_xe",
                                onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 2
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_LabelCustom, { "is-required": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Số hiệu:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "so_hieu",
                            class: "mb-0 w-full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.toaXeForm.so_hieu,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toaXeForm.so_hieu) = $event)),
                                placeholder: "Số hiệu",
                                name: "so_hieu",
                                onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 2
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_LabelCustom, { "is-required": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Mã toa xe:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "ma_toa_xe",
                            class: "mb-0 w-full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.toaXeForm.ma_toa_xe,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.toaXeForm.ma_toa_xe) = $event)),
                                placeholder: "Mã toa xe",
                                name: "ma_toa_xe",
                                onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 12
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Ghi chú:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "ghi_chu",
                            class: "mb-0 w-full"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.toaXeForm.ghi_chu,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.toaXeForm.ghi_chu) = $event)),
                                type: "textarea",
                                autosize: { minRows: 2 },
                                resize: "none",
                                placeholder: "Ghi chú",
                                name: "ghi_chu",
                                onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivRow, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, {
                      cols: 12,
                      "additional-class": "d-flex justify-content-center gap-x-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isCreating)
                          ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                              key: 0,
                              "button-type": _ctx.ButtonsType.ADD,
                              "color-type": _ctx.ButtonTypeColors.PRIMARY,
                              immediate: true,
                              onClick: _cache[8] || (_cache[8] = () => _ctx.submit(true))
                            }, {
                              "button-label": _withCtx(() => [
                                _createTextVNode("Lưu và tiếp tục")
                              ]),
                              _: 1
                            }, 8, ["button-type", "color-type"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ButtonCustom, {
                          "button-type": _ctx.ButtonsType.SAVE,
                          "color-type": _ctx.ButtonTypeColors.SUCCESS,
                          immediate: true,
                          onClick: _cache[9] || (_cache[9] = () => _ctx.submit(false))
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("Lưu")
                          ]),
                          _: 1
                        }, 8, ["button-type", "color-type"]),
                        _createVNode(_component_ButtonCustom, {
                          "button-type": _ctx.ButtonsType.REFRESH,
                          "color-type": _ctx.ButtonTypeColors.WARNING,
                          onClick: _ctx.clear
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("Nhập lại")
                          ]),
                          _: 1
                        }, 8, ["button-type", "color-type", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DanhSachToaXeTable, {
            "cur-page": _ctx.currentPage,
            "delete-externally": false,
            items: _ctx.toaXeItems,
            "per-page": _ctx.perPage,
            "selected-id": _ctx.isCreating ? 0 : _ctx.toaXeId,
            "show-dm-toa-xe": true,
            "show-delete-toa-xe-button-in-modal": true,
            "show-delete-toa-xe-button-in-table": true,
            onDeleteToaXeSuccess: _ctx.fetchData
          }, null, 8, ["cur-page", "items", "per-page", "selected-id", "onDeleteToaXeSuccess"]),
          (_ctx.toaXeItems.length > 0)
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 0,
                page: _ctx.currentPage,
                "page-size": _ctx.perPage,
                total: _ctx.totalItems,
                onChangePage: _cache[11] || (_cache[11] = (value) => (_ctx.currentPage = value)),
                onChangePageSize: _cache[12] || (_cache[12] = (value) => (_ctx.perPage = value))
              }, null, 8, ["page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}